import { gql } from "@apollo/client";
import { PROMO_CODE_FRAGMENT, TRANSACTION_FRAGMENT } from "@graphql/fragments";

export const ALLOCATE_PROMOTIONAL_DOLLARS = gql`
  ${TRANSACTION_FRAGMENT}

  mutation allocatePromotionalDollars($amountInCents: Int!, $destinationGoalId: String!) {
    allocatePromotionalDollars(
      input: { amountInCents: $amountInCents, destinationGoalId: $destinationGoalId }
    ) {
      ...TransactionFragment
    }
  }
`;

export const VERIFY_PROMO_CODE = gql`
  ${PROMO_CODE_FRAGMENT}

  mutation verifyPromotionCode($code: String!) {
    verifyPromotionCode(code: $code) {
      ...PromoCodeFragment
    }
  }
`;

export const REDEEM_PROMO_CODE = gql`
  ${PROMO_CODE_FRAGMENT}

  mutation redeemPromotionCode($code: String!) {
    redeemPromotionCode(code: $code) {
      ...PromoCodeFragment
    }
  }
`;
